var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7777 4.09325C17.3699 3.67745 16.8856 3.3476 16.3527 3.12256C15.8198 2.89752 15.2486 2.78168 14.6717 2.78168C14.0948 2.78168 13.5236 2.89752 12.9907 3.12256C12.4578 3.3476 11.9736 3.67745 11.5658 4.09325L10.7194 4.95579L9.87306 4.09325C9.04931 3.25375 7.93207 2.78212 6.76711 2.78212C5.60215 2.78212 4.48491 3.25375 3.66116 4.09325C2.83741 4.93276 2.37463 6.07137 2.37463 7.25861C2.37463 8.44585 2.83741 9.58446 3.66116 10.424L4.50751 11.2865L10.7194 17.6172L16.9313 11.2865L17.7777 10.424C18.1857 10.0084 18.5093 9.5149 18.7301 8.97177C18.951 8.42865 19.0646 7.84651 19.0646 7.25861C19.0646 6.67071 18.951 6.08857 18.7301 5.54545C18.5093 5.00233 18.1857 4.50886 17.7777 4.09325Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedHeart);
export default __webpack_public_path__ + "static/media/icon-feed-heart.90e2c42fec1ba1eebd00761667c002ca.svg";
export { ForwardRef as ReactComponent };